import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {I18n} from 'react-redux-i18n';
import {Clear} from '@material-ui/icons';
import {withStyles} from '@material-ui/core/styles';

import {EntitiesListWithViewModesCard} from '../index';
import {LoadingLayout} from '../../layouts-common';
import {ACCESS_RIGHTS} from '../../constants';
import {RightAvailability} from '../../containers/index';

import style from './style';

const rightAvailabilityMap = {
  buttonOrganizationPersonaUnlink: [ACCESS_RIGHTS.ORGANIZATION_PERSONA_LINK],
};

class OrganizationPersonasTable extends Component {
  constructor(props) {
    super(props);
    this.actionsCellRenderer = (row) => (
      <RightAvailability accessRights={rightAvailabilityMap.buttonOrganizationPersonaUnlink}>
        <div
          className={this.props.classes.organizationPersonasTable__cell_action}
          onClick={() => this.props.removePersonaFromOrganization(row.index)}
        >
          <Clear />
        </div>
      </RightAvailability>
    );
  }

  get fullScreenColumns() {
    return [
      {
        Header: I18n.t('organizations.personas.table.headers.personas'),
        accessor: 'name',
        minWidth: 150,
        filterable: false,
        sortable: true,
        isShow: true,
      },
      {
        Header: I18n.t('organizations.personas.table.headers.actions'),
        accessor: 'actions',
        Cell: this.actionsCellRenderer,
        minWidth: 50,
        filterable: false,
        sortable: false,
        isShow: true,
      },
    ];
  }

  render() {
    const {
      classes,
      mode,
      isEditMode,
      tableData,
    } = this.props;

    return (
      <LoadingLayout>
        <EntitiesListWithViewModesCard
          mode={mode}
          headersFullWidthMode={this.fullScreenColumns}
          tableData={tableData}
          disabled={isEditMode}
          customClasses={classes}
          fullscreen={false}
          componentHeaderHidden={true}
        />
      </LoadingLayout>
    );
  }
}

OrganizationPersonasTable.propTypes = {
  classes: PropTypes.object,
  isEditMode: PropTypes.bool,
  mode: PropTypes.string,
  tableData: PropTypes.array,
  tableStyles: PropTypes.object,
  removePersonaFromOrganization: PropTypes.func.isRequired,
};

OrganizationPersonasTable.defaultProps = {
  classes: {},
  isEditMode: false,
  mode: '',
  tableData: [],
  tableStyles: {},
};

export default withStyles(style)(OrganizationPersonasTable);
